import { Component, OnInit, forwardRef, Output, EventEmitter, Input, Renderer2, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * A Text editor component wrapper
 */

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextEditorComponent),
      multi: true
    }
  ]
})
export class TextEditorComponent implements OnInit {
  /**
   * getter for the value
   */
  @Input()
  get value(): any {
    return this._value;
  }

  /**
   * setter for the value
   */
  set value(value: any) {
    if (value !== this._value) {
      this._value = value;
      this.onChange(this._value);
    }
  }

  /**
   * Constructor to inject dependency
   * @param renderer instance of renderer2
   * @param element instance of element
   */
  constructor(private renderer: Renderer2, private element: ElementRef) {
    this.onChange = (_: any) => {};
    this.onTouched = () => {};
  }

  /**
   * onChange handler
   */
  private onChange;

  /**
   * onTouched handler
   */
  private onTouched;

  /**
   * value for the model
   */
  private _value = '';

  /**
   * indicate if the element will be disabled
   */
  disabled = false;

  /**
   * broadcast change event
   */
  @Output() changeEvent = new EventEmitter();

  /**
   * broadcast file upload event
   */
  @Output() fileUploadEvent = new EventEmitter();

  /**
   * broadcast file upload event
   */
  @Output() insertLinkEvent = new EventEmitter();

  /**
   * indicate if file upload has to be displayed
   */
  @Input() public showFileUpload: boolean;

  /**
   * ontouch handler
   */
  private onTouch: any = () => {};

  /**
   * initialize component
   */
  ngOnInit(): void {}

  /**
   * set the value to the text editor
   * @param obj value to the text editor
   */
  writeValue(obj: any): void {
    this.value = obj;
  }

  /**
   * register change fundtion to be invoked during change
   * @param fn call function to be invoked during change
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * register touch function to be invoked during touch event
   * @param fn touch function to be invoked during touch event
   */
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  /**
   * set disabled state
   * @param disabled indicate if control will be disabled
   */
  setDisabledState?(disabled: boolean): void {
    this.disabled = disabled;
    this.renderer.setAttribute(this.element.nativeElement, 'disabled', disabled.toString());
  }

  /**
   * broadcast change event
   */
  change() {
    // Angular does not know that the value has changed
    // from our component, so we need to update her with the new value.
    this.changeEvent.emit(this._value);
  }

  /**
   * upload file event emitter
   */
  uploadFile() {
    this.fileUploadEvent.emit();
  }

  /**
   * upload file event emitter
   */
  insertLink() {
    this.insertLinkEvent.emit();
  }
}
